import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "./Login";

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const { data } = await api.post("/auth/register", form);
      setUser(data);
      navigate("/portal", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthShell title="Create Your Account" subtitle="Join XTM FutureSkills Academy to track applications and learning.">
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        {error && <div className="bg-red-500/10 border border-red-500/40 text-red-300 text-sm rounded-xl px-4 py-3" data-testid="register-error">{error}</div>}
        <div>
          <Label htmlFor="rg-name">Full Name</Label>
          <Input id="rg-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="bg-navy-base border-white/15 text-white mt-1" data-testid="register-name-input" />
        </div>
        <div>
          <Label htmlFor="rg-email">Email</Label>
          <Input id="rg-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="bg-navy-base border-white/15 text-white mt-1" data-testid="register-email-input" />
        </div>
        <div>
          <Label htmlFor="rg-password">Password (min 8 characters)</Label>
          <Input id="rg-password" type="password" required minLength={8} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="bg-navy-base border-white/15 text-white mt-1" data-testid="register-password-input" />
        </div>
        <Button type="submit" disabled={submitting} className="w-full bg-orange-600 hover:bg-orange-700 text-white font-semibold transition-colors" data-testid="register-submit-btn">
          {submitting ? "Creating account…" : "Create Account"}
        </Button>
      </form>
      <p className="text-sm text-slate-400 mt-6 text-center">
        Already have an account? <Link to="/login" className="text-orange-400 hover:text-orange-300 font-medium transition-colors" data-testid="login-link">Sign in</Link>
      </p>
    </AuthShell>
  );
}
